<div class="main">
  <div class="top-container">
    <p>Adicionar refeição</p>
    <button (click)="fechar()">
      <mat-icon class="icon">close</mat-icon>
    </button>
  </div>

  <form [formGroup]="form" class="conteudo">
    <mat-form-field appearance="outline" class="seletor">
      <mat-label>Refeição</mat-label>
      <mat-select formControlName="refeicao" placeholder="Selecione uma refeição">
        <mat-option
          *ngFor="let item of refeicoes"
          [disabled]="refeicoesInativas.includes(item)"
          [value]="item"
        >
          {{ item }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="outraSelecionada">
      <mat-label>Outra</mat-label>
      <input matInput formControlName="outra" placeholder="Digite o nome da refeição" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="seletor">
      <span matPrefix class="icone-btn">
        <img alt="hora" src="../../../../../../assets/svg/icons/clock.svg" />
      </span>
      <input
        matInput
        [matTimepicker]="hora"
        placeholder="Selecionar hora*"
        formControlName="hora"
        readonly
      />
      <mat-timepicker appereance="outline" #hora></mat-timepicker>
    </mat-form-field>
  </form>

  <div class="actions">
    <button class="cancelar-btn" (click)="fechar()">Cancelar</button>
    <button
      mat-raised-button
      color="primary"
      [disabled]="form.invalid"
      class="confirmar-btn"
      (click)="adicionar()">
      Adicionar
    </button>
  </div>
</div>
